import { useEffect, useRef } from "react";
import MessageBubble from "./MessageBubble";

export default function MessageList({ messages, chatBoxStyle, styles, theme, showInitialInstructions }) {
    const bottomRef = useRef(null);

    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    const instructionsStyle = {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        minHeight: "100%",
        padding: "30px",
        color: theme.text || "#ffffff",
        opacity: 0.7,
    };

    const titleStyle = {
        fontSize: "24px",
        fontWeight: "bold",
        marginBottom: "20px",
    };

    const contentStyle = {
        fontSize: "16px",
        lineHeight: "1.6",
        maxWidth: "500px",
    };

    return (
        <div style={chatBoxStyle}>
            {showInitialInstructions && messages.length === 0 ? (
                <div style={instructionsStyle}>
                    <h2 style={titleStyle}>Як користуватися AI офіціантом</h2>
                    <div style={contentStyle}>
                        <p>
                            Вітаємо! Це AI-офіціант, який допоможе вам зробити замовлення.
                        </p>
                        <p>
                            Ви можете написати, що хочете замовити,
                            і офіціант допоможе вам з вибором страв з меню.
                        </p>
                        <p>
                            Також доступні функції:
                            <br />- покликати офіціанта
                            <br />- оформити замовлення
                            <br />- залишити анонімний відгук
                            <br />- отримати рекомендації по ваших вподобаннях
                            <br />- попросити принести щось (рахунок, прибори, воду, тощо)
                        </p>
                        <p>
                            Просто напишіть що вам потрібно та натисніть "Надіслати",
                            щоб почати розмову!
                        </p>
                    </div>
                </div>
            ) : (
                <>
                    {messages.map((msg) => (
                        <MessageBubble key={msg.id} message={msg} styles={styles} theme={theme} />
                    ))}
                    <div ref={bottomRef} />
                </>
            )}
        </div>
    );
}
